module.exports = __webpack_public_path__ + "img/33.01e2cbaa.jpg";